import { appConstants } from "../../constants/appconstants";
import { getApiCall, postApiCall } from "../../utils/ApiMethods";


const FetchSupplierPerfDetail = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/supplier-performance/kpi-page-data`, postData);
        var resData = Object.assign({ type: 'SUCCESS_COMAN_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchSupplierPerfInhouseDetail = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/supplier-performance/inhouse-kpi-page-data`, postData);
        var resData = Object.assign({ type: 'SUCCESS_SPM_INHOUSE_ACTION' }, data);
        dispatch(resData);
    };
};


const FetchSupplierPerfFilterDetails = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/supplier-performance/filter-data`, postData);
        var resData = Object.assign({ type: 'SUCCESS_SUPPLIER_PERFORMACE_FILTER_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchSPMDropdownDetails = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/supplier-performance/inhouse-dropdown-filters`, requestObj);
        var resData = Object.assign({ type: 'SUCCESS_VENDOR_LIST_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchSPMSupplierDetails = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/supplier-performance/spminhouse-filter`, requestObj);
        var resData = Object.assign({ type: 'SUCCESS_SPM_SUPPLIERS_ACTION' }, data);
        dispatch(resData);
    };
};



export {
    FetchSupplierPerfDetail,
    FetchSupplierPerfFilterDetails,
    FetchSupplierPerfInhouseDetail,
    FetchSPMDropdownDetails,
    FetchSPMSupplierDetails
}